import {
  arrayOf,
  bool,
  number,
  oneOfType,
  shape,
  string,
  func,
  array,
} from 'prop-types';

const priceTypePropTypes = shape({
  value: oneOfType([string, number]),
  currency: string,
});

const ratePropsType = {
  baseRate: priceTypePropTypes,
  isFreeCancellation: bool,
  isNonRefundable: bool,
  isRecommended: bool,
  bigPoint: shape({
    label: string,
    value: string,
    unit: string,
  }),
  isEnableNewBrandLogo: bool,
  flyerDiscountLabel: string,
  flyerDiscountDescriptionLabel: string,
  isPayAtHotel: bool,
  paymentDiscountType: string,
  paymentDiscountDescription: string,
  penaltyTypeLabel: string,
  penaltyDescriptionLabel: string,
  instantConfirmationLabel: string,
  instantConfirmationDescriptionLabel: string,
  refundType: string,
  perPersonBaseRate: priceTypePropTypes,
};

export const roomCardLeftContentPropTypes = {
  hasSingleOption: bool,
  index: number,
  ...ratePropsType,
};

export const roomCardRightContentPropTypes = {
  rates: arrayOf(shape(ratePropsType)),
  priceHintText: string,
  guestHintText: string,
  enableTotalGuestPrice: bool,
  bigPoint: shape({
    label: string,
    value: string,
    unit: string,
  }),
  ...ratePropsType,
};

export const roomCardTopContentPropTypes = {
  index: number,
  hasSingleOption: bool,
  bedGroups: array,
  squareMeterArea: number,
  selectedBedGroups: array,
  setSelectedBedGroups: func,
  isRecommendRoom: bool,
  isShowRecommended: bool,
  ...ratePropsType,
};

export const roomCardPropTypes = {
  id: string,
  name: string,
  displayPerGuestPrice: bool,
  isRecommendRoom: bool,
  isShowRecommended: bool,
  rates: arrayOf(shape(ratePropsType)),
  bigPoint: string,
  priceHintText: string,
  guestHintText: string,
  guestCount: number,
  onLoadImage: func,
  enableTotalGuestPrice: bool,
  isEnableNewBrandLogo: bool,
  imageCount: number,
  onRoomImageClickHandler: func,
};
